import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface WishlistStore {
  items: string[] // product IDs
  addItem: (product_id: string) => void
  removeItem: (product_id: string) => void
  toggleItem: (product_id: string) => void
  isInWishlist: (product_id: string) => boolean
  clearWishlist: () => void
}

export const useWishlistStore = create<WishlistStore>()(
  persist(
    (set, get) => ({
      items: [],
      
      addItem: (product_id) => {
        const items = get().items
        if (!items.includes(product_id)) {
          set({ items: [...items, product_id] })
        }
      },
      
      removeItem: (product_id) => {
        set({ items: get().items.filter(id => id !== product_id) })
      },
      
      toggleItem: (product_id) => {
        const items = get().items
        if (items.includes(product_id)) {
          get().removeItem(product_id)
        } else {
          get().addItem(product_id)
        }
      },
      
      isInWishlist: (product_id) => {
        return get().items.includes(product_id)
      },
      
      clearWishlist: () => {
        set({ items: [] })
      },
    }),
    {
      name: 'BotTola-wishlist',
    }
  )
)
